import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/Addons.js'
import { DRACOLoader } from 'three/examples/jsm/Addons.js'

var dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath("https://mhreserve.com/wp-content/uploads/reserve/draco/")
var loader = new GLTFLoader()
loader.setDRACOLoader(dracoLoader);

function loadModel(path) {
    return new Promise((resolve, reject) => {
        loader.load(path, (gltf) => {

            gltf.scene.traverse((v) => {
                if (v.isMesh) {
                    v.material = v.material.clone()
                    v.userData.color = new THREE.Color(v.material.color)
                    v.userData.originalColor = new THREE.Color(v.material.color) 
                    if(v.material.map){
                        v.material.map.colorSpace = THREE.SRGBColorSpace
                    }
                    var color = v.material.color

                    if (color.r == 0.3419119715690613) {
                        v.userData.roomType = "studio"
                    }
                   
                    else if (color.r == 0.6444754600524902) {
                       v.userData.roomType = "suite"

                    }
                    else if (color.r == 0.8468683362007141) {
                        if (v.name == "225") {
                            v.userData.roomType = "mastersuite"
                        }
                        else if (v.name == "220") {
                            v.userData.roomType = "suite2"
                        }
                        else if (v.name == "205") {
                            v.userData.roomType = "mastersuite2"
                        }

                    }
                    else if (color.r == 0.6866811513900757) {
                        v.userData.roomType = "studiomc"
                    }
                }
            })

            resolve(gltf.scene)
        })
    })

}

export { loadModel }